export interface PatentDescResponse {
    PATENT_ID: string;
    PN: string;
    DESC_LANG: string;
    DESC_SECTIONS: number[];
    DESC: {
        [key: string]: string;
    }
}
export interface PatentDescApi {
    /**
     * 获取专利描述
     */
    getPatentDesc(payload: {patentId: string ,lang: string}): Promise<string>;
}

export const PatentDescApi = Symbol.for('PatentDescApi');
